//bayer
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";

//bayer custom module
import importfile from "@/constants/navigation/BSA20WK9NGYP/menu/import-file";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVTIbUDiyUw46D": // Dev Bayer BO UP
    case "PVvYhZiGhTlSJb": // Prod Bayer BO EP
      switch (decodeToken()?.sub) {
        case "ID_uZb7r6pkBeFm": // woranooch.duangpratum@bayer.com
          return [...document, ...inventory, ...report];
        case "ID_6k26dnHZyHZL": // Thitima.sukonwimonmal@bayer.com
          return [...fulfillment, ...report];
      }
    default:
      return [
        ...dataManagement,
        ...article,
        ...banner,
        ...inventory,
        ...privileges,
        ...fulfillment,
        ...document,
        ...report,
        ...importfile,
      ];
  }
};

export default renderNavByPermission();
